export default "//file.bilionpass.com/japandx-web/0.0.1/static/arrow-right.e172b614-f31173.svg";